import React from 'react';
import {
  Page,
  Popup,
  Navbar,
  Row,
  Col,
  Card,
  CardContent,
  Button,
  Block
} from 'framework7-react';
import II18 from '../../translate/II18';
import { gae } from '../../helpers/Analytics';
import PropTypes from 'prop-types';
import FocusTrap from '../../helpers/FocusTrap';
import { getIcon } from '../../helpers/utils';

export const WAYS_TO_SIGN = {
  USE_CACHED_SIGNATURE: 'USE_CASHED_SIGNATURE',
  SIGN_ON_DESKTOP: 'SIGN_ON_DESKTOP',
  SIGN_ON_MOBILE: 'SIGN_ON_MOBILE',
  UPLOAD_SIGNATURE: 'UPLOAD_SIGNATURE'
};
export default function SelectWayToSignPopUp(props) {
  const {
    opened,
    onCancel,
    onDone,
    cachedSignature,
    advancedSignature
  } = props;

  const onPopUpCancel = () => {
    gae('SELECT_WAY_TO_SIGN_POP_UP', 'CANCEL');
    onCancel();
  };

  return (
    <Popup
      id={'select_way_to_sign'}
      className="select_way_to_sign"
      tabIndex="-1"
      animate={false}
      opened={Boolean(opened)}
      swipeToClose={false}
      closeByOutsideClick={false}
      closeByBackdropClick={false}
      onPopupOpen={() => {
        gae('SELECT_WAY_TO_SIGN_POP_UP', 'SHOW');
        document.getElementById('select_way_to_sign_options').focus();
      }}
      style={{
        height: 'auto',
        marginTop: -175,
        minWidth: cachedSignature ? 700 : 550
      }}
    >
      <FocusTrap opened={Boolean(opened)} onClose={onPopUpCancel}>
        <Page style={{ background: '#fff', position: 'relative' }}>
          <Navbar title={II18.get('title_please_choose')}></Navbar>

          <div id={'select_way_to_sign_options'} tabIndex={-1}>
            <Block className={'way_to_sign'}>
              {cachedSignature && !advancedSignature && (
                <Button
                  tabIndex={0}
                  className={'button-wrapper'}
                  onClick={() => onDone(WAYS_TO_SIGN.USE_CACHED_SIGNATURE)}
                >
                  <Card id={'useLastSignature'}>
                    <CardContent>
                      <Row>
                        <Col>
                          <img
                            style={{ height: 45, maxWidth: '100%' }}
                            alt={II18.get('title_use_last_signature')}
                            src={cachedSignature}
                          />
                        </Col>
                      </Row>
                    </CardContent>
                  </Card>
                </Button>
              )}
              {(!advancedSignature || window.isTouchDevice) && (
                <Button
                  tabIndex={0}
                  className={'button-wrapper'}
                  onClick={() => onDone(WAYS_TO_SIGN.SIGN_ON_DESKTOP)}
                >
                  <Card id={'signOnScreen'}>
                    <CardContent>
                      <Row>
                        <Col>{getIcon('fa-desktop', 45)}</Col>
                        <Col>{II18.get('title_sign_on_screen')}</Col>
                      </Row>
                    </CardContent>
                  </Card>
                </Button>
              )}
              {process.env.REACT_APP_ENV !== 'ratiodata' && (
                <Button
                  tabIndex={0}
                  className={'button-wrapper'}
                  onClick={() => onDone(WAYS_TO_SIGN.SIGN_ON_MOBILE)}
                >
                  <Card id={'signOnMobile'}>
                    <CardContent>
                      <Row>
                        <Col>{getIcon('f7:device_phone_landscape', 45)}</Col>
                        <Col>{II18.get('title_sign_on_mobile')}</Col>
                      </Row>
                    </CardContent>
                  </Card>
                </Button>
              )}
              {!advancedSignature && (
                <Button
                  tabIndex={0}
                  className={'button-wrapper'}
                  onClick={() => onDone(WAYS_TO_SIGN.UPLOAD_SIGNATURE)}
                >
                  <Card id={'uploadSignature'}>
                    <CardContent>
                      <Row>
                        <Col>{getIcon('fa-upload', 45)}</Col>
                        <Col>{II18.get('title_upload_signature')}</Col>
                      </Row>
                    </CardContent>
                  </Card>
                </Button>
              )}
            </Block>
          </div>

          <Row style={{ padding: 5, borderTop: '1px solid #eee' }}>
            <Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button onClick={onPopUpCancel}>
                {II18.get('title_cancel')}
              </Button>
            </Col>
          </Row>
        </Page>
      </FocusTrap>
    </Popup>
  );
}

SelectWayToSignPopUp.propTypes = {
  advancedSignature: PropTypes.bool,
  opened: PropTypes.any,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
  cachedSignature: PropTypes.any
};
